export const FETCH_FORECASTS_REQUEST = 'FETCH_FORECASTS_REQUEST';
export const FETCH_FORECASTS_SUCCESS = 'FETCH_FORECASTS_SUCCESS';
export const FETCH_FORECASTS_FAILURE = 'FETCH_FORECASTS_FAILURE';

export const FETCH_ACTIVITY_FORECASTS_REQUEST = 'FETCH_ACTIVITY_FORECASTS_REQUEST';
export const FETCH_ACTIVITY_FORECASTS_SUCCESS = 'FETCH_ACTIVITY_FORECASTS_SUCCESS';
export const FETCH_ACTIVITY_FORECASTS_FAILURE = 'FETCH_ACTIVITY_FORECASTS_FAILURE';

export const FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST = 'FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST';
export const FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS = 'FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE = 'FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE';

export const fetchForecastsRequest = () => ({ type: FETCH_FORECASTS_REQUEST });
export const fetchForecastsSuccess = (data) => ({ type: FETCH_FORECASTS_SUCCESS, payload: data });
export const fetchForecastsFailure = (error) => ({ type: FETCH_FORECASTS_FAILURE, payload: error });

export const fetchActivityForecastsRequest = (params = {}) => ({ type: FETCH_ACTIVITY_FORECASTS_REQUEST, payload: params });
export const fetchActivityForecastsSuccess = (data) => ({ type: FETCH_ACTIVITY_FORECASTS_SUCCESS, payload: data });
export const fetchActivityForecastsFailure = (error) => ({ type: FETCH_ACTIVITY_FORECASTS_FAILURE, payload: error });

export const fetchActivityForecastByIdRequest = (forecastId) => ({ type: FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST, payload: forecastId });
export const fetchActivityForecastByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS, payload: data });
export const fetchActivityForecastByIdFailure = (error) => ({ type: FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE, payload: error });




